import { CustomFacet, CustomFacetValue, RangeFacet } from '@catalog/const';
import { Action } from '@ngrx/store';

export const TOGGLE_MULTIPLE_FACET = '[Search] Search Toggle Multiple Facet';
export const TOGGLE_FACET = '[Search] Search Toggle Facet';
export const SET_FACET_VALUE = '[Search] Search Set Facet Value';
export const SET_FACET_RANGE_VALUE = '[Search] Search Set Facet Range Value';
export const CLEAR_FACET_VALUE = '[Search] Search Clear Facet Value';
export const CLEAR_ALL_FACETS = '[Search] Search Clear All Facets';

export class ToggleFacet implements Action {
  readonly type = TOGGLE_FACET;

  constructor(public payload: { facet: CustomFacet; value: CustomFacetValue; force?: boolean }) {}
}

export class SetFacetValue implements Action {
  readonly type = SET_FACET_VALUE;

  constructor(public payload: { facet: CustomFacet; value: number | string | boolean }) {}
}
export class SetFacetRangeValue implements Action {
  readonly type = SET_FACET_RANGE_VALUE;

  constructor(public payload: { facet: RangeFacet; value: number[] }) {}
}

export class ClearFacetValue implements Action {
  readonly type = CLEAR_FACET_VALUE;

  constructor(public payload: { facet: CustomFacet | RangeFacet }) {}
}

export class ClearAllFacets implements Action {
  readonly type = CLEAR_ALL_FACETS;

  constructor() {}
}

export type SearchActiveFacetsAction =
  | ToggleFacet
  | SetFacetValue
  | SetFacetRangeValue
  | ClearFacetValue
  | ClearAllFacets;
